import styled, { css } from 'styled-components';

import { media } from '@theme/media';
import { COLORS } from '@theme/colors';
import { FONT_SIZE, LETTER_SPACING, LINE_HEIGHT, typography } from '@theme/font';
import { UploadField } from '@components/uploadField';
import { InputField } from '@components/inputField';
import { SIDEBAR_WIDTH } from '@components/blocks';
import { OFFSET } from '@theme/helpers';

export const textStyles = css`
  ${typography({})};

  ${media.mobile} {
    ${typography({ size: FONT_SIZE.M })};
  }
`;

export const PointTitle = styled.h3<{ upperCase?: boolean }>`
  ${textStyles};
  text-transform: ${({ upperCase }) => (upperCase ? 'upperCase' : 'normal')};
  margin-top: ${OFFSET.S};

  ${media.tablet} {
    margin-bottom: ${OFFSET.XS};
  }

  ${media.desktop} {
    margin-top: 0;
    margin-right: 20px;
  }
`;

export const containerStyles = css`
  display: grid;
  padding: ${OFFSET.S};

  ${media.tablet} {
    padding: ${OFFSET.M} ${OFFSET.M} ${OFFSET.M} ${OFFSET.L};
  }

  ${media.desktop} {
    padding: ${OFFSET.L} ${OFFSET.M} ${OFFSET.L} ${OFFSET.L};
    grid-template-columns: 39% auto calc(24% - 200px);
  }
`;

export const Block = styled.div`
  ${containerStyles};

  ${media.desktop} {
    grid-template-columns: 29% auto calc(30% - 200px);
  }
`;

export const Sidebar = styled.div`
  width: ${SIDEBAR_WIDTH}px;
  display: none;
  position: sticky;
  top: 0;
  padding: ${OFFSET.S} ${OFFSET.M} ${OFFSET.M};
  height: var(--vh);
  overflow: auto;

  ${media.tablet} {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
`;

export const SidebarHeadline = styled.div`
  ${typography({ spacing: LETTER_SPACING.M })};

  ${media.tablet} {
    display: inline-block;
  }
`;

export const BlockContent = styled.div``;

export const BlockCopy = styled.div<{ marginTop?: number }>`
  margin-top: ${({ marginTop }) => marginTop || 0}px;
  ${typography({ size: FONT_SIZE.M, spacing: LETTER_SPACING.S })}
`;

export const ScrollLinkContainer = styled.div`
  ${typography({ height: LINE_HEIGHT.S, spacing: LETTER_SPACING.M })};
  position: relative;
  padding: 0 0 2px;
  cursor: pointer;

  &:before {
    content: '\\2192';
    font-size: ${FONT_SIZE.XS};
    display: block;
    position: absolute;
    left: -11px;
    top: 0;
    transition: transform 0.2s ease-in-out;
  }

  &:hover {
    &:before {
      transform: rotate(90deg);
    }
  }
`;

export const CheckedIcon = styled.i`
  display: inline-block;
  transform: rotate(45deg);
  height: 12px;
  width: 6px;
  border-bottom: 1px solid ${COLORS.BLACK};
  border-right: 1px solid ${COLORS.BLACK};
  margin-right: 4px;
  margin-bottom: 4px;
`;

export const FieldContainer = styled.div<{ disabled?: boolean }>`
  display: flex;
  flex-direction: column;
  padding: 14px 0 ${OFFSET.S};

  ${media.tablet} {
    border-top: 1px solid ${({ disabled }) => (disabled ? COLORS.EDWARD : COLORS.BLACK)};
    background-color: ${COLORS.WHITE};
  }
`;

export const FieldLabel = styled.p`
  margin: 14px 0 0;
`;

export const StepTitle = styled.button<{ disabled?: boolean }>`
  padding: 0;
  letter-spacing: ${LETTER_SPACING.S};
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0;
  text-transform: uppercase;
  color: ${({ disabled }) => (disabled ? COLORS.EDWARD : COLORS.BLACK)};
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')}; ;
`;

export const UploadInputField = styled(UploadField)`
  margin-top: 14px;
`;

export const DownloadButtonWrapper = styled.div`
  margin-top: 4px;

  > button {
    ${typography({ height: LINE_HEIGHT.S, spacing: LETTER_SPACING.S })};
    text-transform: uppercase;
    height: 34px;
  }

  ${media.tablet} {
    margin-top: 50px;
  }
`;

export const InputFieldComponent = styled(InputField)`
  margin-top: 14px;
  height: 34px;
`;
